/* eslint-disable @angular-eslint/directive-selector */
import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({ selector: '[scrollEvent]', })
export class ScrollEventDirective {
  @Output() scrolled = new EventEmitter<Event>();

  @HostListener('scroll', ['$event'])
  onScroll(event: Event) {
    this.scrolled.emit(event);
  }
}
